import type { Address } from 'viem'
import {
  FUNKIT_NATIVE_TOKEN,
  RELAY_NATIVE_TOKEN,
  RELAY_TERMINAL_STATUSES,
} from './constants'
import {
  CheckoutRefundState,
  CheckoutState,
  type RelayExecutionInfo,
} from './types'

/**
 * Converts a token address within Funkit the corresponding Relay token address.
 */
export function convertFunToRelayTokenAddress(address: Address): Address {
  if (address.toLowerCase() === FUNKIT_NATIVE_TOKEN.toLowerCase()) {
    return RELAY_NATIVE_TOKEN
  }

  return address
}

export function getRelayExecutionRefundState(
  info: RelayExecutionInfo,
): CheckoutRefundState | undefined {
  switch (info.status) {
    case 'refund':
      return CheckoutRefundState.REFUNDED
    default:
      return undefined
  }
}

export function getRelayExecutionState(
  info: RelayExecutionInfo,
): CheckoutState {
  switch (info.status) {
    case 'success':
      return CheckoutState.COMPLETED
    case 'failure':
    case 'refund':
      return CheckoutState.CHECKOUT_ERROR
    default:
      return CheckoutState.PENDING_RECEIVAL
  }
}

/**
 * Checks whether the Relay execution has reached a terminal status.
 */
export function isRelayExecutionTerminalStatus(
  info: RelayExecutionInfo,
): boolean {
  return RELAY_TERMINAL_STATUSES.includes(info.status)
}
